<template>
  <div class="home">
    <Header />

    <!-- Banner -->
    <section id="home" class="hero-section">
      <!-- <video id="myVideo" autoplay muted loop playsinline>
        <source src="../static/introduce.mp4" type="video/mp4" />
        您的浏览器不支持视频播放
      </video> -->
      <video
          :src="videoBanner"
          id="myVideo" 
          autoplay 
          muted 
          loop
          webkit-playsinline
          playsinline
          :poster="bannerVideoPoster"
        >
          您的浏览器不支持视频播放
        </video>
      <div class="masker">
        <div class="hero-content">
          <h1 class="hero-title">
            成为世界一流的
            <br />
            电子粉体和金属化解决方案供应商
          </h1>
          <p class="hero-subtitle">
            Become a world-class supplier of electronic powder and metallization
            solutions
          </p>
        </div>
        <div class="scroll-indicator">
          <img class="scroll-circle" src="../static/home/mouse.png" alt="" />
          <p>scroll down</p>
        </div>
      </div>
    </section>

    <!-- 以材料进步 创建美好生活 -->
    <section id="about" class="section module-about" ref="aboutSection">
      <div class="section-container" data-aos="fade-up">
        <div class="about-content">
          <div class="about-left" data-aos="fade-right" data-aos-delay="200">
            <h2 class="section-title">
              以材料进步
              <br />
              创建美好生活
            </h2>
            <p class="section-description">
              星翰新材料科技有限公司成立于2019年，总部位于苏州市吴江区。公司专注于光伏和半导体领域的新材料研发、生产和销售，
              致力于成为世界一流的电子粉体和金属化解决方案供应商。我们以技术创新为驱动，为客户提供高品质的产品和服务。
            </p>
            <div class="learn-more-btn" @click="toAbout">
              了解更多
              <div class="circle">
                <img src="../static/home/circle_arrow_right.png" alt="" />
              </div>
            </div>

            <div class="stats-grid">
              <div class="stat-item">
                <NumberCounter
                  :target="400"
                  suffix="+"
                  :start-animation="aboutVisible"
                  ref="stat1"
                />
                <p class="stat-label">雇员人数</p>
              </div>
              <div class="stat-item">
                <NumberCounter
                  :target="3"
                  suffix=""
                  :start-animation="aboutVisible"
                />
                <p class="stat-label">参与制定国家标准</p>
              </div>
              <div class="stat-item">
                <NumberCounter
                  :target="30"
                  suffix="%"
                  :start-animation="aboutVisible"
                />
                <p class="stat-label">市场占有率</p>
              </div>
              <div class="stat-item">
                <NumberCounter
                  :target="4"
                  suffix=""
                  :start-animation="aboutVisible"
                />
                <p class="stat-label">自有实验室平台</p>
              </div>
            </div>
          </div>
          <div class="about-right" data-aos="fade-left" data-aos-delay="300">
            <div class="video-thumbnail" @click="playVideo">
              <div class="play-button">
                <img src="../static/home/play.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="module-partners" data-aos="fade-up" data-aos-delay="200">
          <h3 class="partners-title">多家知名企业的共同选择</h3>
          <HorizontalScroll :items="partnerLogos" :gap="30" :speed="1">
            <template v-slot="{ index, item }">
              <div class="partner-logo">
                <img :src="item" alt="" />
              </div>
            </template>
          </HorizontalScroll>
        </div>
      </div>
    </section>

    <!-- 聚焦核心领域 -->
    <section id="solutions" class="section module-solutions">
      <div class="section-container" data-aos="fade-up">
        <h2 class="section-title-center" data-aos="fade-up">聚焦核心领域</h2>
        <p
          class="section-subtitle-center"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          提供科学解决方案
        </p>

        <div class="solutions-grid">
          <div
            class="solution-card"
            data-aos="fade-right"
            data-aos-delay="200"
            @click="toSolutions('guangfu')"
          ></div>
          <div
            class="solution-card"
            data-aos="fade-left"
            data-aos-delay="300"
            @click="toSolutions('bandaoti')"
          ></div>
        </div>
      </div>
    </section>

    <!-- 汇聚顶尖人才 -->
    <section id="rd" class="section module-rd" ref="rdSection">
      <div class="section-container" data-aos="fade-up">
        <div class="rd-content">
          <div class="rd-left" data-aos="fade-right" data-aos-delay="200">
            <h2 class="rd-title">汇聚顶尖人才</h2>
            <p class="rd-subtitle">打造卓越科研能力</p>
            <div class="line"></div>
            <p class="rd-description">
              公司目前拥有博士20余人，硕士50余人，本科以上学历占比97%以上。公司与中国科学技术大学、东华大学、苏州大学、新加坡国立大学等知名高校和科研院所建立深度合作。
            </p>
            <p class="rd-description">
              公司累计获得专利、商标70余项，并通过了ISO9001、ISO140001认证。
            </p>
            <div class="tag">
              <img src="../static/home/bar_chart.png" alt="" />
              数据截止至2025年底
            </div>
          </div>

          <div class="rd-right" data-aos="fade-left" data-aos-delay="300">
            <div class="rd-stats-grid">
              <div class="rd-stat-item large item1" data-aos="zoom-in">
                <NumberCounter
                  :target="10"
                  suffix="%"
                  :start-animation="rdVisible"
                />
                <p>研发投入占营收比</p>
              </div>
              <div class="rd-stat-item item2" data-aos="zoom-in">
                <NumberCounter
                  :target="70"
                  suffix="+"
                  :start-animation="rdVisible"
                />
                <p>专利及认证数量</p>
                <div class="tags">
                  <div class="btn" @click="toRD">了解更多</div>
                  <img src="../static/home/approve.png" alt="" />
                </div>
              </div>
              <div class="rd-stat-item item3" data-aos="zoom-in">
                <div class="rd-stat-item-top">
                  <div>
                    <NumberCounter
                      :target="70"
                      suffix="+"
                      :start-animation="rdVisible"
                    />
                    <p>博士及硕士</p>
                  </div>
                  <div>
                    <NumberCounter
                      :target="10"
                      suffix="+"
                      :start-animation="rdVisible"
                    />
                    <p>合作高校与科研机构</p>
                  </div>
                </div>
                <div class="btn" @click="toRD">了解更多科研实力与成果</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻动态 -->
    <section id="news" class="section module-news">
      <div class="section-container" data-aos="fade-up">
        <div class="news_content">
          <div class="news-header" data-aos="fade-up">
            <div>
              <h2 class="news-title">了解我们的</h2>
              <h2 class="news-sub-title">新闻动态</h2>
            </div>
            <div class="learn-more-btn" @click="toNews">
              了解更多
              <div class="circle">
                <img src="../static/home/circle_arrow_right.png" alt="" />
              </div>
            </div>
          </div>

          <div class="news-carousel" data-aos="fade-up" data-aos-delay="200">
            <el-carousel
              :interval="50000"
              arrow="always"
              indicator-position="none"
              height="470px"
            >
              <el-carousel-item v-for="(item, index) in newsList" :key="index">
                <div class="news-cards">
                  <div
                    v-for="(news, i) in item"
                    :key="i"
                    class="news-card"
                    @click="selectNews(news)"
                  >
                    <div class="news-type">
                      <div class="dot"></div>
                      <div class="name">{{ news.categoryName }}</div>
                    </div>
                    <h3 class="text-ellipsis-two">{{ news.title }}</h3>
                    <p class="text-ellipsis-three">{{ news.introduction }}</p>
                    <div class="news-date">
                      <div class="day">{{ news.date }}</div>
                      <div class="year_month">{{ news.year_month }}</div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 小屏幕上显示这个 -->
          <div
            class="news-carousel-hidden"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <el-carousel
              :interval="50000"
              arrow="always"
              indicator-position="none"
              height="290px"
            >
              <el-carousel-item
                v-for="(item, index) in newsListHidden"
                :key="index"
              >
                <div class="news-cards">
                  <div
                    v-for="(news, i) in item"
                    :key="i"
                    class="news-card"
                    @click="selectNews(news)"
                  >
                    <div class="news-type">
                      <div class="dot"></div>
                      <div class="name">{{ news.categoryName }}</div>
                    </div>
                    <h3 class="text-ellipsis-two">{{ news.title }}</h3>
                    <p class="text-ellipsis-three">{{ news.description }}</p>
                    <div class="news-date">
                      <div class="day">{{ news.date }}</div>
                      <div class="year_month">{{ news.year_month }}</div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <contactModule />

    <Footer />

    <!-- 视频播放弹窗 -->
    <el-dialog
      :visible.sync="videoDialogVisible"
      :fullscreen="true"
      :show-close="true"
      @close="closeVideoDialog"
      class="video-dialog"
    >
      <div class="video-container" @click.stop="">
        <video
          ref="videoPlayer"
          :src="videoSrc"
          :poster="videoPoster"
          controls
          webkit-playsinline="true"
          playsinline="true"
          style="width: 100%; height: 100%"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";
import contactModule from "../components/contactModule.vue";
import { HomeAPI } from "../api/api";
import {imgBaseUrl} from "../api/config";
import dayjs from "dayjs";
export default {
  name: "Home",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    contactModule,
  },
  created() {
    HomeAPI.getAllHomeData().then((res) => { 
      console.log('首页数据', res);
      const { famousEnterprises, newsList} = res
      this.partnerLogos = (famousEnterprises || []).map(item => `${imgBaseUrl}${item.imageUrl}`)
      this.news = (newsList || []).map((item)=>{
        return{
          ...item,
          date: dayjs(item.createTime).format('DD'),
          year_month: dayjs(item.createTime).format('YYYY-MM'),
        }
      })
    });
    // HomeAPI.getHomeNews().then((res) => { 
    //   console.log('新闻', res);
    //   this.contact = res
    // });
    // /public-api/home/news
  },
  data() {
    return {
      aboutVisible: false,
      rdVisible: false,
      partnerLogos: [],
      news: [],
      // news: [
      //   {
      //     id: 1,
      //     title: "济源星翰新材料再获殊荣这就是新闻标题",
      //     description:
      //       "这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，这是新闻描述内容，展示了公司的最新动态和成就...",
      //     date: "25 2023-9",
      //   },
      //   {
      //     id: 2,
      //     title: "济源星翰新材料再获殊荣这就是新闻标题",
      //     description: "这是新闻描述内容，展示了公司的最新动态和成就...",
      //     date: "25 2023-9",
      //   },
      //   {
      //     id: 3,
      //     title: "济源星翰新材料再获殊荣这就是新闻标题",
      //     description: "这是新闻描述内容，展示了公司的最新动态和成就...",
      //     date: "25 2023-9",
      //   },
      //   {
      //     id: 4,
      //     title: "公司荣获行业创新奖",
      //     description: "在技术创新方面取得重大突破，获得行业认可...",
      //     date: "15 2023-10",
      //   },
      //   {
      //     id: 5,
      //     title: "公司荣获行业创新奖",
      //     description: "在技术创新方面取得重大突破，获得行业认可...",
      //     date: "15 2023-10",
      //   },
      //   {
      //     id: 6,
      //     title: "公司荣获行业创新奖",
      //     description: "在技术创新方面取得重大突破，获得行业认可...",
      //     date: "15 2023-10",
      //   },
      // ],
      partnerScrollOptions: {
        step: 0.5,
        hoverStop: true,
        direction: 2,
        singleWidth: 0,
        waitTime: 0,
        openTouch: false,
      },
      videoDialogVisible: false,
      bannerVideoPoster: require("../static/home/banner_cover.png"),
      videoBanner: require("../static/introduce.mp4"),
      videoSrc: require("../static/video.mp4"), // 替换为实际的视频路径
      videoPoster: require("../static/home/video_cover.png"), // 可选：视频封面图
    };
  },

  computed: {
    newsList() {
      return this.splitArray(this.news, 3);
    },
    newsListHidden() {
      return this.splitArray(this.news, 2);
    },

    // partnerLogos() {
    //   const images = [
    //     require("@/static/companys/logo_1.jpg"),
    //     require("@/static/companys/logo_2.jpg"),
    //     require("@/static/companys/logo_3.jpg"),
    //     require("@/static/companys/logo_4.jpg"),
    //     require("@/static/companys/logo_5.jpg"),
    //     require("@/static/companys/logo_6.jpg"),
    //     require("@/static/companys/logo_7.jpg"),
    //     require("@/static/companys/logo_8.jpg"),
    //     require("@/static/companys/logo_9.jpg"),
    //     require("@/static/companys/logo_10.jpg"),
    //     require("@/static/companys/logo_11.jpg"),
    //     require("@/static/companys/logo_12.jpg"),
    //     require("@/static/companys/logo_13.jpg"),
    //     require("@/static/companys/logo_14.jpg"),
    //     require("@/static/companys/logo_15.jpg"),
    //     require("@/static/companys/logo_16.jpg"),
    //     require("@/static/companys/logo_17.jpg"),
    //     require("@/static/companys/logo_18.jpg"),
    //     require("@/static/companys/logo_19.jpg"),
    //     require("@/static/companys/logo_20.jpg"),
    //   ];
    //   return [...images];
    // },
  },
  mounted() {
    this.setupSectionObserver();
    // this.handleWechatAutoplay()
  },
  methods: {
    handleWechatAutoplay() {
    // 处理微信浏览器自动播放
    const video = document.getElementById('myVideo');
    
    // 如果是微信浏览器
    const ua = navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf('micromessenger') !== -1;
    
    if (isWeixin) {
       console.log('weixin');
      // 监听WeixinJSBridge准备完成
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', () => {
            this.playVideo1(video);
          }, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', () => {
            this.playVideo1(video);
          });
          document.attachEvent('onWeixinJSBridgeReady', () => {
            this.playVideo1(video);
          });
        }
      } else {
        this.playVideo1(video);
      }
    } else {
      // 非微信浏览器直接播放
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // 自动播放失败，显示播放按钮
          this.showPlayButton = true;
        });
      }
    }
  },
  
  playVideo1(video) {
    WeixinJSBridge.invoke('getNetworkType', {}, 
    // 成功回调
    (res) => {
      video.play().then(() => {
        console.log('微信视频播放成功');
      }).catch((error) => {
        console.error('微信视频播放失败:', error);
        this.showPlayButton = true;
      });
    },
    // 失败回调（第四个参数）
    (err) => {
      console.log('获取网络类型失败，尝试直接播放');
      video.play().catch(() => {
        this.showPlayButton = true;
      });
    }
  );
  },
    splitArray(arr, size) {
      if (!arr.length || size <= 0) return [];
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        const chunk = arr.slice(i, i + size);
        result.push(chunk);
      }
      return result;
    },

    // 监听内容进入可视区域  -- 数字开始滚到
    setupSectionObserver() {
      const options = {
        root: null,
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      };

      this.sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          switch (target.dataset.section) {
            case "about":
              this.aboutVisible = true;
              break;
            case "rd":
              this.rdVisible = true;
              break;
            default:
              break;
          }
          // 触发后取消观察，避免重复计算
          this.sectionObserver.unobserve(target);
        });
      }, options);

      this.registerSection(this.$refs.aboutSection, "about");
      this.registerSection(this.$refs.rdSection, "rd");
    },
    registerSection(sectionEl, name) {
      if (!sectionEl || !this.sectionObserver) return;
      sectionEl.dataset.section = name;
      this.sectionObserver.observe(sectionEl);
    },
    playVideo() {
      this.videoDialogVisible = true;
      // 确保视频在弹窗打开后可以播放
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play();
        }
      });
    },
    closeVideoDialog() {
      this.videoDialogVisible = false;
      // 关闭弹窗时暂停视频
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },

    selectNews(news) {
      this.$router.push({ name: "NewsDetail", params: { id: news.id || 1 } });
    },
    toRD(){
      this.$router.push({ name: "Rd" });
    },
     toAbout(){
      this.$router.push({ name: "About" });
    },
    toNews(){
      this.$router.push({ name: "News" });
    },
    toSolutions(type){
      this.$router.push({ name: "Solutions",query: { type: type } });
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 751px) {
  .home {
    width: 100%;
  }

  .learn-more-btn {
    cursor: pointer;
    width: 136px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 16px;
    background: #0248ff;
    border-radius: 50px;
    color: #fff;

    .circle {
      width: 24px;
      height: 24px;
      margin-left: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &:hover {
      opacity: 0.8;
    }

    &.light {
      background: #fff;
      color: #000;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateX(-50%) translateY(0);
    }

    50% {
      transform: translateX(-50%) translateY(-10px);
    }
  }

  /* Hero Section */
  .hero-section {
    position: relative;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

    #myVideo {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }

    .masker {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      text-align: center;
    }

    .hero-content {
      max-width: 1400px;
      padding: 0 40px;
      z-index: 1;

      .hero-title {
        font-size: 80px;
        font-weight: bold;
        line-height: 90px;
        margin-bottom: 20px;
        animation: fadeInUp 1s ease;
      }

      .hero-subtitle {
        font-family: OutfitFont;
        font-size: 24px;
        color: rgba(255,255,255,0.7);
        opacity: 0.8;
        animation: fadeInUp 1s ease 0.3s both;
      }
    }

    .scroll-indicator {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      animation: bounce 2s infinite;
      opacity: 0.8;

      .scroll-circle {
        width: 20px;
        height: 32px;
      }

      p {
        font-size: 12px;
        color: #aaa;
      }
    }
  }

  /* Section Styles */
  .section {
    padding: 100px 0;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      // padding: 0 40px;
    }
  }

  /* About Section */
  .module-about {
    background: #fff;

    .about-content {
      // display: grid;
      // grid-template-columns: 1fr 1fr;
      display: flex;
      align-items: stretch;
      gap: 200px;
      margin-bottom: 80px;
      // align-items: center;

      .about-left {
        // padding-right: 40px;
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 428px;
        overflow: hidden;

        .section-title {
          font-size: 54px;
          color: #363636;
          line-height: 64px;
        }

        .section-description {
          font-size: 16px;
          color: #808080;
          line-height: 26px;
        }

        .stats-grid {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .stat-item {
            text-align: center;

            .number-counter {
              font-size: 50px;
              color: #363636;
              display: block;
              margin-bottom: 10px;
              font-weight: bold;
            }

            .stat-label {
              white-space: nowrap;
              font-size: 16px;
              color: #808080;
            }
          }
        }
      }

      .about-right {
        position: relative;
        flex-shrink: 0;
        flex-grow: 0;

        .video-thumbnail {
          position: relative;
          width: 600px;
          height: 428px;
          background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
            url("../static/home/video_cover.png") center/cover;
          border-radius: 16px;
          cursor: pointer;
          transition: transform 0.3s ease;
          overflow: hidden;

          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 65px;
            height: 65px;
            // background: rgba(255, 255, 255, 0.9);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            color: #409eff;
            transition: all 0.3s ease;
          }

          .play-button:hover {
            transform: translate(-50%, -50%) scale(1.2);
          }
        }
      }
    }
  }

  .module-partners {
    margin-top: 114px;

    .partners-title {
      text-align: center;
      font-size: 20px;
      color: #000000;
      margin-bottom: 40px;
    }

    .partner-logo {
      transition: all 0.3s ease;
    }

    // .partner-logo:hover {
    //   background: #e4e7ed;
    //   transform: none;
    // }

    .partner-logo img {
      object-fit: contain;
    }
  }

  /* Solutions Section */
  .module-solutions {
    background: #f5f7fa;

    .section-title-center {
      font-size: 54px;
      color: #9e9e9e;
      line-height: 64px;
      text-align: center;
      font-weight: bold;
    }

    .section-subtitle-center {
      font-size: 54px;
      line-height: 64px;
      color: #000;
      text-align: center;
      margin-bottom: 73px;
      font-weight: bold;
    }
  }

  .solutions-grid {
    // display: grid;
    // grid-template-columns: repeat(2, 1fr);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .solution-card {
      width: 690px;
      height: 380px;
      position: relative;
      border-radius: 20px;
      color: #fff;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.4s ease;
      background-size: cover;
      background-position: center;
    }

    .solution-card:first-child {
      background: url("../static/home/solar.png") center/cover;
    }

    .solution-card:last-child {
      background: url("../static/home/pan.png") center/cover;
    }

    .solution-card:hover {
      transform: scale(1.02);
    }
  }

  .solution-icon {
    position: absolute;
    top: 30px;
    right: 30px;
    font-size: 60px;
    opacity: 0.8;
  }

  /* RD Section */
  .module-rd {
    background: url("../static/home//rd_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background-position: center top;
    color: #fff;

    .rd-content {
      display: grid;
      grid-template-columns: 3fr 4fr;
      gap: 130px;

      .rd-left {
        display: flex;
        flex-direction: column;

        .rd-title {
          font-size: 54px;
          line-height: 64px;
          color: #c3d4ff;
        }

        .rd-subtitle {
          font-size: 54px;
          line-height: 64px;
          color: #fff;
          opacity: 0.9;
        }

        .line {
          margin: 68px 0 40px;
          width: 100%;
          height: 1px;
          background: #8dacf2;
          opacity: 0.5;
        }

        .rd-description {
          text-align: justify;
          font-size: 16px;
          line-height: 1.8;
          opacity: 0.9;
        }

        .tag {
          margin-top: 263px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 178px;
          height: 36px;
          border-radius: 8px;
          border: 1px solid #8dacf2;
          color: #8dacf2;
          font-size: 14px;

          img {
            margin-right: 4px;
          }
        }
      }

      .rd-right {
        .rd-stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          height: 100%;

          .number-counter {
            font-size: 60px;
            color: #fff;
            display: block;
            margin-bottom: 10px;
          }

          p {
            font-size: 16px;
            color: #fff;
            opacity: 0.9;
            margin-bottom: 10px;
          }

          .item1 {
            grid-row: span 2;
            border-radius: 8px;
            padding-left: 50px;
            background: url("../static/home/rd_bg1.png");
            background-size: 100% 100%;

            .number-counter {
              position: relative;
              left: -16px;
              font-size: 100px;
            }
          }

          .item2 {
            position: relative;
            border-radius: 8px;
            padding-top: 10px;
            padding-left: 50px;
            background: url("../static/home/rd_bg2.png");
            background-size: 100% 100%;

            .tags {
              width: calc(100% - 80px);
              display: flex;
              align-items: flex-end;
              justify-content: space-between;
              position: absolute;
              bottom: 40px;

              .btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 30px;
                background: rgba(2, 72, 255, 0.1);
                border-radius: 15px;
                border: 1px solid #ffffff;
                opacity: 0.6;
                font-size: 14px;
                color: #ffffff;
                cursor: pointer;
              }
            }
          }

          .item3 {
            border-radius: 8px;
            position: relative;
            padding-top: 10px;
            padding-left: 50px;
            background: url("../static/home/rd_bg3.png");
            background-size: 100% 100%;

            .number-counter {
              font-size: 50px;
            }

            .rd-stat-item-top {
              display: flex;
              align-items: flex-start;
              gap: 20px;
            }

            .btn {
              line-height: 1;
              position: absolute;
              bottom: 33px;
              width: 260px;
              height: 47px;
              background: #018ffc;
              border-radius: 23px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  /* News Section */
  .module-news {
    background: #fff;

    .news_content {
      display: grid;
      grid-template-columns: 1fr 3fr;
    }

    .news-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .news-title {
        font-size: 54px;
        line-height: 64px;

        color: #9e9e9e;
      }

      .news-sub-title {
        font-size: 54px;
        line-height: 64px;
        color: #000;
        font-weight: bold;
        margin-bottom: 57px;
      }
    }

    .news-carousel{
      /deep/ .el-carousel__arrow--right {
        width: 48px;
        height: 48px;
        top: unset;
        transform: none;
        bottom: 0px;
        right: 20px;
        background: #ecf3fd;
        color: #000;
      }

      /deep/ .el-carousel__arrow--left {
        width: 48px;
        height: 48px;
        top: unset;
        left: unset;
        transform: none;
        bottom: 0px;
        right: 85px;
        background: #ecf3fd;
        color: #000;
      }

      .news-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 30px;
        padding: 0 20px;

        .news-card {
          background: #fff;
          padding: 38px;
          border-radius: 8px;
          cursor: pointer;
          // transition: all 0.3s ease;
          border-radius: 10px;
          border: 1px solid rgba(206, 206, 206, 0.3);
          background: url("../static/home/star.png") no-repeat right 35px bottom
            33px;

          .news-type {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 96px;
            height: 29px;
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid rgba(206, 206, 206, 0.3);
            margin-bottom: 18px;

            .dot {
              margin-right: 4px;
              width: 6px;
              height: 6px;
              background: #0248ff;
              border-radius: 50%;
            }

            .name {
              font-size: 14px;
              color: #9d9d9d;
            }
          }

          h3 {
            margin-bottom: 15px;
            font-weight: 600;
            font-size: 20px;
            color: #363636;
          }

          .text-ellipsis-three {
            line-height: 1.5;
            height: 4.5em;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          .text-ellipsis-two {
            line-height: 1.5;
            height: 3em;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          p {
            margin-bottom: 80px;
            font-size: 12px;
            color: #8f8f8f;
          }

          .news-date {
            .day {
              font-weight: bold;
              font-size: 42px;
              color: #363636;
              // line-height: 75px;
            }

            .year_month {
              font-size: 14px;
              color: #9d9d9d;
            }
          }
        }

        .news-card:hover {
          transform: scale(1.01);
          background: #0248ff url("../static/home/add.png") no-repeat right 35px
            bottom 33px;

          .news-type {
            background: transparent;

            .dot {
              background: #fff;
            }

            .name {
              color: #fff;
            }
          }

          h3 {
            color: #fff;
          }

          p {
            color: #fff;
          }

          .news-date {
            .day {
              color: #fff;
            }

            .year_month {
              color: #fff;
            }
          }
        }

        // .news-card.active {
        //   background: #409eff;
        // }
      }
    }

    .news-carousel-hidden {
      display: none;
    }
  }

  /* Contact Section */
  .module-contract {
    background: linear-gradient(
      to top right,
      #0049ff,
      #096efe 50%,
      #2cdaf5
    ); // 带透明度

    color: #fff;
    text-align: center;

    .contract_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .contact-title {
      font-size: 40px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
    }
  }

  .video-dialog {
    /deep/ .el-dialog {
      margin: 0;
      padding: 0;
      max-width: 100%;
      max-height: 100%;
      background: rgba(0, 0, 0, 0.8);
    }

    /deep/ .el-dialog__header {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      z-index: 10;
    }

    /deep/ .el-dialog__headerbtn {
      font-size: 28px;
      color: #fff;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/.el-dialog__body {
      padding: 0 !important;
    }

    .video-container {
      width: 100%;
      height: 100vh;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      video {
        width: 960px !important;
        height: 540px !important;
      }
    }
  }
}

// mobile
@media (max-width: 750px) {
  .home {
    width: 100%;
  }

  .learn-more-btn {
    cursor: pointer;
    width: 78px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 12px;
    background: #0248ff;
    border-radius: 25px;
    color: #fff;

    .circle {
      width: 12px;
      height: 12px;
      margin-left: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &.light {
      background: #fff;
      color: #000;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateX(-50%) translateY(0);
    }

    50% {
      transform: translateX(-50%) translateY(-10px);
    }
  }

  /* Hero Section */
  .hero-section {
    position: relative;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

    #myVideo {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }

    .masker {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      text-align: center;
    }

    .hero-content {
      width: 100%;
      padding: 0 24px;
      z-index: 1;

      .hero-title {
        font-size: 35px;
        font-weight: bold;
        line-height: 40px;
        margin-bottom: 10px;
        animation: fadeInUp 1s ease;
      }

      .hero-subtitle {
        font-family: OutfitFont;
        font-size: 12px;
        color: rgba(255,255,255,0.7);
        opacity: 0.8;
        animation: fadeInUp 1s ease 0.3s both;
      }
    }

    .scroll-indicator {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      animation: bounce 2s infinite;
      opacity: 0.8;

      .scroll-circle {
        width: 20px;
        height: 32px;
      }

      p {
        font-size: 12px;
        color: #aaa;
      }
    }
  }

  /* Section Styles */
  .section {
    padding: 50px 0;
    .section-container {
      width: 100%;
      padding: 0 24px;
    }
  }
 
  /* About Section */
  .module-about {
    background: #fff;

    .about-content {
      display: flex;
      flex-direction: column;
      gap: 30px;
      // margin-bottom: 40px;
      // align-items: center;

      .about-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 272px;
        overflow: hidden;

        .section-title {
          font-size: 27px;
          color: #363636;
          line-height: 32px;
        }

        .section-description {
          font-size: 12px;
          color: #808080;
          line-height: 17px;
        }

        .stats-grid {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .stat-item {
            text-align: center;

            .number-counter {
              font-size: 25px;
              color: #363636;
              display: block;
              margin-bottom: 5px;
              font-weight: bold!important;
            }

            .stat-label {
              white-space: nowrap;
              font-size: 12px;
              color: #808080;
            }
          }
        }
      }

      .about-right {
        position: relative;
        flex-shrink: 0;
        flex-grow: 0;

        .video-thumbnail {
          position: relative;
          width: 100%;
          padding-top: 71.3%;
          // height: 214px;
          background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
            url("../static/home/video_cover.png") center/cover;
          border-radius: 16px;
          cursor: pointer;
          transition: transform 0.3s ease;
          overflow: hidden;

          .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 65px;
            height: 65px;
            // background: rgba(255, 255, 255, 0.9);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            color: #409eff;
            transition: all 0.3s ease;
          }

          .play-button:hover {
            transform: translate(-50%, -50%) scale(1.2);
          }
        }
      }
    }
  }

  .module-partners {
    margin-top: 30px;

    .partners-title {
      text-align: center;
      font-size: 12px;
      color: #000000;
      margin-bottom: 20px;
    }

    .partner-logo {
      transition: all 0.3s ease;
    }

    // .partner-logo:hover {
    //   background: #e4e7ed;
    //   transform: none;
    // }

    .partner-logo img {
      width: 83px;
      height: 22px;
      object-fit: contain;
    }
  }

  /* Solutions Section */
  .module-solutions {
    background: #f5f7fa;

    .section-title-center {
      font-size: 27px;
      color: #9e9e9e;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
    }

    .section-subtitle-center {
      font-size: 27px;
      line-height: 32px;
      color: #000;
      text-align: center;
      margin-bottom: 31px;
      font-weight: bold;
    }
  }

  .solutions-grid {
    // display: grid;
    // grid-template-columns: repeat(2, 1fr);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .solution-card {
      width: 100%;
      padding-top: 55%;
      position: relative;
      border-radius: 10px;
      color: #fff;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.4s ease;
    }

    .solution-card:first-child {
      background: url("../static/home/solar.png") center/cover;
    }

    .solution-card:last-child {
      background: url("../static/home/pan.png") center/cover;
    }
  }

  .solution-icon {
    position: absolute;
    top: 30px;
    right: 30px;
    font-size: 60px;
    opacity: 0.8;
  }

  /* RD Section */
  .module-rd {
    background: url("../static/home//rd_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background-position: center top;
    color: #fff;

    .rd-content {
      display: flex;
      flex-direction: column;
      gap: 33px;

      .rd-left {
        display: flex;
        flex-direction: column;

        .rd-title {
          font-size: 27px;
          line-height: 32px;
          color: #c3d4ff;
        }

        .rd-subtitle {
          font-size: 27px;
          line-height: 32px;
          color: #fff;
          opacity: 0.9;
        }

        .line {
          margin: 32px 0 20px;
          width: 100%;
          height: 1px;
          background: #8dacf2;
          opacity: 0.5;
        }

        .rd-description {
          text-align: justify;
          font-size: 12px;
          line-height: 1.8;
          opacity: 0.9;
        }

        .tag {
          margin-top: 20px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 24px;
          border-radius: 4px;
          border: 1px solid #8dacf2;
          color: #8dacf2;
          font-size: 12px;

          img {
            margin-right: 4px;
          }
        }
      }

      .rd-right {
        .rd-stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          height: 100%;

          .number-counter {
            font-size: 30px;
            color: #fff;
            display: block;
            margin-bottom: 5px;
          }

          p {
            font-size: 12px;
            color: #fff;
            opacity: 0.9;
            margin-bottom: 5px;
          }

          .item1 {
            height: 252px;
            grid-row: span 2;
            border-radius: 4px;
            padding-left: 25px;
            background: url("../static/home/rd_bg1.png");
            background-size: 100% 100%;

            .number-counter {
              position: relative;
              left: -8px;
              font-size: 50px;
            }
          }

          .item2 {
            position: relative;
            border-radius: 4px;
            padding-top: 5px;
            padding-left: 25px;
            background: url("../static/home/rd_bg2.png");
            background-size: 100% 100%;

            .tags {
              width: calc(100% - 40px);
              display: flex;
              align-items: flex-end;
              justify-content: space-between;
              position: absolute;
              bottom: 20px;

              .btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 64px;
                height: 17px;
                background: rgba(2, 72, 255, 0.1);
                border-radius: 15px;
                border: 1px solid #ffffff;
                opacity: 0.6;
                font-size: 12px;
                color: #ffffff;
              }
              img{
                width: 32px;
                height: 32px;
              }
            }
          }

          .item3 {
            border-radius: 8px;
            position: relative;
            padding-top: 10px;
            padding-left: 25px;
            background: url("../static/home/rd_bg3.png");
            background-size: 100% 100%;

            .number-counter {
              font-size: 25px;
            }

            .rd-stat-item-top {
              display: flex;
              align-items: flex-start;
              gap: 10px;
            }

            .btn {
              line-height: 1;
              position: absolute;
              bottom: 17px;
              width: 130px;
              height: 25px;
              background: #018ffc;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 10px;
            }
          }
        }
      }
    }
  }

  /* News Section */
  .module-news {
    background: #fff;

    .news_content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .news-header {
      display: flex;
      flex-direction: column;
      // align-items: flex-start;

      .news-title {
        font-size: 27px;
        line-height: 32px;

        color: #9e9e9e;
      }

      .news-sub-title {
        font-size: 27px;
        line-height: 32px;
        color: #000;
        font-weight: bold;
        margin-bottom: 30px;
      }
    }

    .news-carousel {
      /deep/ .el-carousel__arrow--right {
        width: 48px;
        height: 48px;
        top: unset;
        transform: none;
        bottom: 0px;
        right: 20px;
        background: #ecf3fd;
        color: #000;
      }

      /deep/ .el-carousel__arrow--left {
        width: 48px;
        height: 48px;
        top: unset;
        left: unset;
        transform: none;
        bottom: 0px;
        right: 85px;
        background: #ecf3fd;
        color: #000;
      }

      .news-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 30px;
        padding: 0 20px;

        .news-card {
          background: #fff;
          padding: 38px;
          border-radius: 8px;
          cursor: pointer;
          // transition: all 0.3s ease;
          border-radius: 10px;
          border: 1px solid rgba(206, 206, 206, 0.3);
          background: url("../static/home/star.png") no-repeat right 35px bottom
            33px;

          .news-type {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 96px;
            height: 29px;
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid rgba(206, 206, 206, 0.3);
            margin-bottom: 18px;

            .dot {
              margin-right: 4px;
              width: 6px;
              height: 6px;
              background: #0248ff;
              border-radius: 50%;
            }

            .name {
              font-size: 14px;
              color: #9d9d9d;
            }
          }

          h3 {
            margin-bottom: 15px;
            font-weight: 600;
            font-size: 20px;
            color: #363636;
          }

          .text-ellipsis-three {
            line-height: 1.5;
            height: 4.5em;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          .text-ellipsis-two {
            line-height: 1.5;
            height: 3em;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          p {
            margin-bottom: 80px;
            font-size: 12px;
            color: #8f8f8f;
          }

          .news-date {
            .day {
              font-weight: bold;
              font-size: 42px;
              color: #363636;
              // line-height: 75px;
            }

            .year_month {
              font-size: 14px;
              color: #9d9d9d;
            }
          }
        }

        .news-card:hover {
          transform: scale(1.01);
          background: #0248ff url("../static/home/add.png") no-repeat right 35px
            bottom 33px;

          .news-type {
            background: transparent;

            .dot {
              background: #fff;
            }

            .name {
              color: #fff;
            }
          }

          h3 {
            color: #fff;
          }

          p {
            color: #fff;
          }

          .news-date {
            .day {
              color: #fff;
            }

            .year_month {
              color: #fff;
            }
          }
        }

        // .news-card.active {
        //   background: #409eff;
        // }
      }
    }
    .news-carousel{
      display: none;
    }
    .news-carousel-hidden {
      display: block;
    }

    .news-carousel-hidden {
      /deep/ .el-carousel__arrow--right {
        width: 24px;
        height: 24px;
        top: unset;
        transform: none;
        bottom: 0px;
        right: 0px;
        background: #ecf3fd;
        color: #000;
      }

      /deep/ .el-carousel__arrow--left {
        width: 24px;
        height: 24px;
        top: unset;
        left: unset;
        transform: none;
        bottom: 0px;
        right: 46px;
        background: #ecf3fd;
        color: #000;
      }

      .news-cards {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 5px;

        .news-card {
          background: #fff;
          padding: 15px;
          border-radius: 4px;
          cursor: pointer;
          border: 1px solid rgba(206, 206, 206, 0.3);
          background: url("../static/home/star.png") no-repeat right 0 bottom
            0 ~"/ 60px 60px";

          .news-type {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 80px;
            height: 22px;
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid rgba(206, 206, 206, 0.3);
            margin-bottom: 9px;

            .dot {
              margin-right: 4px;
              width: 3px;
              height: 3px;
              background: #0248ff;
              border-radius: 50%;
            }

            .name {
              font-size: 12px;
              color: #9d9d9d;
            }
          }

          h3 {
            margin-bottom: 7px;
            font-weight: 600;
            font-size: 13px;
            color: #363636;
          }

          .text-ellipsis-three {
            line-height: 1.5;
            height: 4.5em;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          .text-ellipsis-two {
            line-height: 1.5;
            height: 3em;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          p {
            margin-bottom: 42px;
            font-size: 12px;
            color: #8f8f8f;
          }

          .news-date {
            .day {
              font-weight: bold;
              font-size: 21px;
              color: #363636;
              // line-height: 75px;
            }

            .year_month {
              font-size: 10px;
              color: #9d9d9d;
            }
          }
        }
      }
    }
  }

  /* Contact Section */
  .module-contract {
    background: linear-gradient(
      to top right,
      #0049ff,
      #096efe 50%,
      #2cdaf5
    ); // 带透明度

    color: #fff;
    text-align: center;

    .contract_wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .contact-title {
      font-size: 40px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: bold;
    }
  }

  .video-dialog {
    /deep/ .el-dialog {
      margin: 0;
      padding: 0;
      max-width: 100%;
      max-height: 100%;
      background: rgba(0, 0, 0, 0.8);
    }

    /deep/ .el-dialog__header {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      z-index: 10;
    }

    /deep/ .el-dialog__headerbtn {
      font-size: 28px;
      color: #fff;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/.el-dialog__body {
      padding: 0 !important;
    }

    .video-container {
      width: 100%;
      height: 100vh;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      video {
        width: 100% !important;
        height: 540px !important;
      }
    }
  }
}
</style>
